/**
 * DebugExerciseWidgetPage — standalone, iframe-friendly host for a single
 * Natural-Language Debug Feedback exercise.
 *
 * Route: /learn/agentic-mastery/:slug/exercises/:exerciseId
 *
 * Slides (Marp) can't render a React component server-side, so they embed
 * this route in an <iframe>. The page is intentionally chrome-free: no
 * AppRail/sidebar, just the widget on a padded surface so it sits cleanly
 * inside a slide.
 */

import React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import DebugFeedbackBlock from "../components/DebugFeedbackBlock";

export default function DebugExerciseWidgetPage() {
  const { slug, exerciseId } = useParams<{
    slug: string;
    exerciseId: string;
  }>();

  if (!slug || !exerciseId) {
    return null;
  }

  return (
    <Box
      sx={{
        maxWidth: 760,
        mx: "auto",
        px: { xs: 2, sm: 4 },
        py: { xs: 3, sm: 5 },
      }}
    >
      <DebugFeedbackBlock slug={slug} exerciseId={exerciseId} />
    </Box>
  );
}
